var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegistryMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.3 6.85714C2.0625 6.85714 1.1 5.85714 1.1 4.57143C1.1 3.32143 2.0625 2.28571 3.3 2.28571C4.50313 2.28571 5.5 3.32143 5.5 4.57143C5.5 5.85714 4.50313 6.85714 3.3 6.85714ZM18.7 6.85714C17.4625 6.85714 16.5 5.85714 16.5 4.57143C16.5 3.32143 17.4625 2.28571 18.7 2.28571C19.9031 2.28571 20.9 3.32143 20.9 4.57143C20.9 5.85714 19.9031 6.85714 18.7 6.85714ZM19.8 8C21.0031 8 22 9.03571 22 10.2857V11.4286C22 12.0714 21.4844 12.5714 20.9 12.5714H18.6313C18.3906 10.8929 17.4281 9.46429 16.0187 8.67857C16.4312 8.28571 16.9813 8 17.6 8H19.8ZM11 8C8.86875 8 7.15 6.21429 7.15 4C7.15 1.82143 8.86875 0 11 0C13.0969 0 14.85 1.82143 14.85 4C14.85 6.21429 13.0969 8 11 8ZM13.6125 9.14286C15.8125 9.14286 17.6 11 17.6 13.2857V14.2857C17.6 15.25 16.8438 16 15.95 16H6.05C5.12187 16 4.4 15.25 4.4 14.2857V13.2857C4.4 11 6.15312 9.14286 8.35312 9.14286H8.62813C9.35 9.5 10.1406 9.71429 11 9.71429C11.825 9.71429 12.6156 9.5 13.3375 9.14286H13.6125ZM5.94688 8.67857C4.5375 9.46429 3.575 10.8929 3.33437 12.5714H1.1C0.48125 12.5714 0 12.0714 0 11.4286V10.2857C0 9.03571 0.9625 8 2.2 8H4.4C4.98438 8 5.53438 8.28571 5.94688 8.67857Z",
    fill: "#AAAAAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegistryMenuIcon);
export default __webpack_public_path__ + "static/media/registry-menu-icon.2f050c969f3174014da33634cba31c3e.svg";
export { ForwardRef as ReactComponent };